package org.hs_soft.runmynesto.domain.model.home.user

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class UserInfoHeaderEnum : TitleEnum {
    GENERAL,
    CHECKOUT,
    RIGHT;

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            GENERAL -> strings.general
            CHECKOUT -> strings.devices
            RIGHT -> strings.right
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                GENERAL -> strings.general
                CHECKOUT -> strings.devices
                RIGHT -> strings.right
            }
        }
}